module.exports = __webpack_public_path__ + "static/media/1015810.794db8c4.png";